module.exports = __webpack_public_path__ + "static/media/кафетерий.95d47cb9.jpg";